import React, { FC } from 'react';

import { FileText24 } from '../../../icons';
import { Typography } from '../../Typography';
import { Stack } from '../../Stack';


type NoOptionsProps = {
    allowInput?: boolean;
};

export const NoOptions: FC<NoOptionsProps> = ({ children, allowInput }) => (
    <Stack
        pt={allowInput ? 2 : 4}
        px={4}
        pb={4}
        direction='row'
        spacing={2}
        color='grayscale.shade85'
    >
        <FileText24
            sx={({ spacing }) => ({
                width: spacing(5),
                height: spacing(5),
            })}
        />
        <Typography variant='regularCaption1'>{children}</Typography>
    </Stack>
);
